<template>
    <span v-if="fight.duplicatedPair" class="icon has-text-warning" :data-tooltip="translate('admin_fights_manage.duplicated_pair')">
        <i class="fa fa-exclamation-triangle" />
    </span>
</template>

<script setup lang="ts">
    import { OrganizerComplexFight } from "../Common/Fights/types";
    import { translate } from "../Common/translations";

    defineProps<{
        fight: OrganizerComplexFight;
    }>();
</script>

<style scoped></style>
